import { ApplicantInterviewers } from '@app/models/recruiting/applicant-interviewers.model';
import { ApplicantInterviews } from '@app/models/recruiting/applicant-interviews.model';
import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { Translatable } from '@app/types/translatable.type';

export class CompletionProgressColumn extends Column {
    title = 'applicant-tracker.interviews-table.completionProgress';
    property = 'applicantInterviewers';
    sortable = false;
    type: CellDisplay = CellDisplay.string;

    // TODO: https://gethumi.atlassian.net/browse/SQE-3738 To be refactored and fetched from backend
    getDisplayPropertyValue(applicantInterview: ApplicantInterviews): Translatable {
        let submittedFeedbackAmt = 0;

        applicantInterview.applicantInterviewers.forEach((applicantInterviewer: ApplicantInterviewers) => {
            if (applicantInterviewer.isSubmitted) {
                submittedFeedbackAmt += 1;
            }
        });

        return {
            key: 'applicant-tracker.interviews-table.feedbackAmountOfInterviewers',
            params: {
                feedbackAmount: submittedFeedbackAmt,
                length: applicantInterview.applicantInterviewers.length,
            },
        };
    }
}
